export default __webpack_public_path__ + "static/media/WINE9.7703f852.jpg";